<template>
  <div class="dialog-container">
    <div class="header">{{ title }}</div>
    <div class="center van-hairline--top">
      <div class="form">
        <div class="form-item">
          <div class="form-label">原始需求量:</div>
          <van-field v-model="outTerminal.originalTank" type="digit" v-reset-page/>车=
          <van-field v-model="outTerminal.originalWeight" type="digit" v-reset-page/>吨=
          <van-field v-model="outTerminal.originalVolume" type="digit" v-reset-page/>万方
        </div>
        <div class="tip">注：1车≈20吨≈3万方</div>
        <div v-if="telDisabled" class="form-item">
          <div class="form-label">审批通知:</div>
          <van-field
            class="form-input"
            type="text"
            v-reset-page
            :formatter="formatterTelephones"
            v-model="outTerminal.telephones"
          />
          <!-- placeholder="请输入通知手机号，多个请用英文逗号隔开！" -->
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <van-button
        v-if="
          outTerminal.status == null ||
          outTerminal.status == '' ||
          outTerminal.status == '10'
        "
        class="btn save-btn"
        @click="saveDayPlan"
        >保存</van-button
      > -->
      <van-button class="btn submit-btn" @click="submitDayPlan"
        >提交</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "EditDialog",
  props: {
    title: {
      type: String,
      default: "LNG日指定提报",
    },
    inTerminal: Object,
  },
  computed: {
    outTerminal() {
      let outTerminal = this.inTerminal;
      if (this.inTerminal.status == "50") {
        //变更审核中
        outTerminal.originalTank = this.inTerminal.changeTank;
        outTerminal.originalWeight = this.inTerminal.changeWeight;
        outTerminal.originalVolume = this.inTerminal.changeVolume;
      }
      return outTerminal;
    },
    telDisabled() {
      return this.inTerminal.status != "40" && this.inTerminal.status != "50";
    },
  },
  watch: {
    "outTerminal.originalTank"(value) {
      if (!value) {
        return;
      }
      if (value % 1 != 0) {
        this.$toast({
          type: "fail",
          message: "请填写1的倍数",
          duration: 1500,
        });
        return;
      }
      this.outTerminal.originalWeight = this.outTerminal.originalTank * 20;
      this.outTerminal.originalVolume = this.outTerminal.originalTank * 3;
    },
    "outTerminal.originalWeight"(value) {
      if (!value) {
        return;
      }
      if (value % 20 != 0) {
        this.$toast({
          type: "fail",
          message: "请填写20的倍数",
          duration: 1500,
        });
        return;
      }
      this.outTerminal.originalTank = this.outTerminal.originalWeight / 20;
      this.outTerminal.originalVolume = this.outTerminal.originalTank * 3;
    },
    "outTerminal.originalVolume"(value) {
      if (!value) {
        return;
      }
      if (value % 3 != 0) {
        this.$toast({
          type: "fail",
          message: "请填写20的倍数",
          duration: 1500,
        });
        return;
      }
      this.outTerminal.originalTank = this.outTerminal.originalVolume / 3;
      this.outTerminal.originalWeight = this.outTerminal.originalTank * 20;
    },
  },
  methods: {
    formatterTelephones (value) {
      if (!value) {
        return value
      }
      /* eslint-disable */
      return value.replace(/[^\d\,]/g,'');
      /* eslint-disable */
    },
    saveDayPlan() {
      this.$emit("saveDayPlan", this.outTerminal);
    },
    submitDayPlan() {
      this.$emit("submitDayPlan", this.outTerminal);
    },
  },
};
</script>
<style lang="stylus" scoped>
.dialog-container >>> .van-cell {
  height: 64px;
  width: 88px;
  // line-height: 64px;
  font-size: 28px;
  border: 1PX solid rgba(102, 102, 102, 1);
  border-radius: 10px;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
}

.dialog-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 670px;

  // height: 539px;
  .header {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    line-height: 80px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin: 0 0 40px 0;
    padding:0 24px;

    .btn {
      // width: 176px;
      flex:1;
      height: 72px;
      opacity: 1;
      font-size: 32px;
      font-weight: 400;
      line-height: 45px;
    }

    .save-btn {
      background: rgba(255, 255, 255, 1);
      border: 1PX solid rgba(225, 32, 32, 1);
      border-radius: 36px;
      color: rgba(225, 32, 32, 1);
      margin-right: 15px;
    }

    .submit-btn {
      background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
      border-radius: 40px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .center {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
    color: #393939;
    opacity: 1;
    padding: 20px 0;

    .form {
      .form-item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;

        .form-label {
          width: 147px;
          text-align: right;
          font-size: 26px;
          line-height: 37px;
          color: rgba(57, 57, 57, 1);
          opacity: 1;
          margin-right: 10px;
        }

        .form-input-number {
          width: 88px;
          height: 64px;
          border: 1PX solid rgba(102, 102, 102, 1);
          border-radius: 10px;
          margin: 0 8px;
        }

        .form-input {
          flex: 1;
        }
      }
    }

    .tip {
      text-align: center;
      font-size: 24px;
      color: rgba(225, 32, 32, 1);
      line-height: 33px;
      margin-top: 20px;
    }
  }
}
</style>